import { EcoHero, TrustStats } from "@/components/home/EcoHero";
import { WhatSudigiDoes } from "@/components/home/WhatSudigiDoes";
import { MkRail } from "@/components/mk/MkRail";
import { ServicesGrid } from "@/components/home/ServicesGrid";
import { PackageCards } from "@/components/home/PackageCards";
import { PackageBuilder } from "@/components/home/PackageBuilder";
import { CommunityTeaser } from "@/components/home/CommunityTeaser";
import { FinalCTA } from "@/components/home/FinalCTA";
import { SectionHeading } from "@/components/site/ui";
import { useState } from "react";
import { useSeo, ORG_JSONLD } from "@/lib/seo";

export default function Home() {
    const [selected, setSelected] = useState([]);
    useSeo({
        title: "SuDigi — Brand Visibility, Digital Marketing, Opportunities & Community",
        description: "SuDigi helps businesses build visibility, discover opportunities, and connect with PR experts, influencers, podcasts, events and the right people to grow — plus full digital marketing services from ₹199.",
        jsonLd: ORG_JSONLD,
    });
    return (
        <>
            <EcoHero />
            <TrustStats />
            <WhatSudigiDoes />
            <MkRail kind="opportunities" eyebrow="Marketplace" title="Discover Opportunities" subtitle="One platform. Hundreds of ways to get your brand noticed." bg="bg-teal-950" />
            <MkRail kind="brands" eyebrow="Featured" title="Brands Making Noise" subtitle="Businesses building their presence on SuDigi." />

            {/* ===== Digital Marketing Solutions (preserved core) ===== */}
            <section className="bg-teal-800 pt-20 pb-2 grain">
                <div className="container-x text-center flex flex-col items-center">
                    <SectionHeading center eyebrow="Marketing Solutions" title="Everything Your Brand Needs to Grow Online."
                        subtitle="From strategy to content, campaigns to conversions — build your complete digital presence with SuDigi." />
                </div>
            </section>
            <ServicesGrid heading={false} />
            <PackageCards />
            <PackageBuilder selected={selected} setSelected={setSelected} />

            <MkRail kind="experts" eyebrow="Experts" title="Connect With an Expert" subtitle="Verified professionals who can build your next growth chapter." bg="bg-teal-950" />
            <MkRail kind="influencers" eyebrow="Creators" title="Find Creators Your Audience Trusts" subtitle="Collaborate with verified influencers across every category." />
            <MkRail kind="podcasts" eyebrow="Podcasts" title="Get Your Story on the Mic" subtitle="Apply as a guest on podcasts your audience already follows." bg="bg-teal-950" />
            <MkRail kind="events" eyebrow="Events" title="Where Business Happens" subtitle="Discover events, seminars and webinars to put your brand in the room." />
            <CommunityTeaser />
            <FinalCTA />
        </>
    );
}
